
import React from 'react';
import { FlowRender } from "../flow-render";
import {commaValidator, Text} from "../prm/text";
import { Name } from "../prm/name";
import { RadioButton } from "../prm/radio-button";
import {GreyBox} from "../../client/funcs/utils";

const income_from = new Text(new Name("income_from"));
income_from.setValidator(commaValidator);

const income_to = new Text(new Name("income_to"));
income_to.setValidator(commaValidator);

const net_worth_from = new Text(new Name("net_worth_from"));
net_worth_from.setValidator(commaValidator);
const net_worth_to = new Text(new Name("net_worth_to"));
net_worth_to.setValidator(commaValidator);

const tax_bracket = new RadioButton(
  new Name("tax_bracket"),
  [
    new Name("0_15", "0-15%"),
    new Name("15_32", "15.1%-32%"),
    new Name("32_50", "32.1%-50%"),
    new Name("50_more", "50.1%+"),
  ]
)

class IncomeNetWorth extends FlowRender {
  constructor(index) {
    super(index, [
      income_from,
      income_to,
      net_worth_from,
      net_worth_to,
      tax_bracket,
    ]);

    income_from.onChangeCallback = this.onChange;
    income_to.onChangeCallback = this.onChange;
    net_worth_from.onChangeCallback = this.onChange;
    net_worth_to.onChangeCallback = this.onChange;
    tax_bracket.onChangeCallback = this.onChange;
  }

  onChange = (component, newState) => {}

  canNavigateNext(component) {
    const highlight_rects = [];

    [ income_from, income_to, net_worth_from, net_worth_to, tax_bracket ]
      .forEach(prm => prm.isFilledElseHighlight(component.state, highlight_rects));

    if (highlight_rects.length > 0) {
      component.setState({ highlight_rects });
      return null;
    }

    return component.getRootUrl() + "/source_of_funds";
  }

  renderFromTo = (component, label, prm_from, prm_to) => {
    const container_style = {
      display: "flex",
      margin: "1rem auto",
      alignItems: "center",
    }
    const input_style = {
      width: "100%",
      textAlign: "center",
    }
    const text_style = {
      flex: "1",
      fontSize: "1.2rem",
    }
    const dollar_style = {
      paddingTop: "1.2rem",
      paddingRight: "0.3rem",
      fontSize: "1.4rem",
    }
    return (
      <div style={container_style}>
        <div style={text_style}>
          { label }
        </div>
        <div style={dollar_style}>$</div>
        <div style={{flex: "1"}}>
          { prm_from.renderInputDiv(component, input_style, "From")}
        </div>
        <div style={{ width: "2rem"}}/>
        <div style={dollar_style}>$</div>
        <div style={{flex: "1"}}>
          { prm_to.renderInputDiv(component, input_style, "To") }
        </div>
      </div>
    )
  }

  renderTaxBracket = (component) => {
    const container_style = {
      display: "flex",
      margin: "2rem auto",
      alignItems: "center",
    }
    const text_style = {
      flex: "1",
      fontSize: "1.2rem",
    }
    const dump_tax = index => {
      const cb_style = {
        float: "none",
        marginRight: "1rem",
      }
      return (
        <div>
          { tax_bracket.renderCheckbox(index, component, cb_style) }
          { tax_bracket.buttonList[index].label }
        </div>
      );
    }

    return (
      <div style={container_style}>
        <div style={text_style}>
          Tax Bracket
        </div>
        <div style={{ flex: "2.1", display: "flex"}}>
          { dump_tax(0) }
          <div style={{ flex: "1"}}/>
          { dump_tax(1) }
          <div style={{ flex: "1"}}/>
          { dump_tax(2) }
          <div style={{ flex: "1"}}/>
          { dump_tax(3) }
        </div>
      </div>
    )
  }

  render = component => {
    const width = "75%";
    const section_style = {
      paddingTop: "0",
      paddingBottom: "0",
    }
    const box_style = {
      padding: "0 1rem",
      margin: "0 auto",
      width,
    }
    const text_style = {
      width,
      margin: "0 auto",
      fontSize: "1.2rem",
    }

    return (
      <div>
        { this.renderHighlightRects(component) }
        { this.renderTitle(component, "Your Financial Snapshot", width) }
        { this.renderProgress(component, width ) }
        <div style={{height: "2rem"}}/>
        <section className="section" style={section_style}>
          <div style={text_style}>An approximation for each of these is fine.</div>
          <div style={{height: "1rem"}}/>
          <GreyBox style={box_style}>
            { this.renderFromTo(component, "Annual Income", income_from, income_to) }
            { this.renderFromTo(component, "Net Worth", net_worth_from, net_worth_to) }
            { this.renderTaxBracket(component) }
          </GreyBox>
        </section>
        { this.renderNextButtonRow(component, true) }
      </div>
    )
  }

}

export { IncomeNetWorth };
